import AdminLayout from '../../components/dashboard/admin/AdminLayout';
import QuoteManagement from '../../components/admin/quotes/QuoteManagement';

const AdminQuotes = () => {
  return (
    <AdminLayout>
      <QuoteManagement />
    </AdminLayout>
  );
};

export default AdminQuotes;